<template>
  <div class="pagging">
    <span>当前共{{ total || 0 }}条，共{{ last_page || 1 }}页</span>
    <!-- <span @click="goFirst()">首页</span> -->
    <span class="page-btn" @click="pre()"
      ><i class="el-icon-arrow-left"></i
    ></span>
    <span class="page-btn active">{{ current_page }}</span>
    <!-- <span>共{{ last_page }}页</span> -->
    <span class="page-btn" @click="next()"
      ><i class="el-icon-arrow-right"></i
    ></span>
    <span>
      跳至
      <input
        @keyup.enter="jumper()"
        class="input jumpper"
        oninput="value=value.replace(/[^\d]/, '')"
        v-model="jumperPage"
        type="text"
      />
      页
    </span>
    <!-- <span @click="goLast()">尾页</span> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      jumperPage: "",
    };
  },
  props: ["current_page", "last_page", "total"],
  methods: {
    pre() {
      this.$emit("pre");
    },
    next() {
      this.$emit("next");
    },
    goFirst() {
      this.$emit("goFirst");
    },
    goLast() {
      this.$emit("goLast");
    },
    jumper() {
      if (this.jumperPage >= this.last_page) {
        this.jumperPage = this.last_page;
      }
      this.$emit("jumper", this.jumperPage);
    },
  },
};
</script>

<style lang="scss" scoped>
.pagging {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 42px;
  font-size: 12px;
  &.center {
    justify-content: center;
  }
  & > span {
    padding: 4px 0;
    background: #fff;
    &:not(:last-child) {
      margin-right: 10px;
    }
  }
  .page-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 1px solid var(--new-border);
    cursor: pointer;
    &.active {
      color: var(--new-text-primary-bg);
      background: var(--new-primary-color);
    }
  }
  .jumpper {
    margin: 0 10px;
    width: 50px;
    height: 30px;
    background: var(-new-text-primary-bg);
    border-radius: 1px;
    border: 1px solid var(--new-border);
  }
}
</style>
